import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import "./Login.css";
import { api } from '../../config';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [errorPopup, setErrorPopup] = useState(false); // State for error popup

  
  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');
    //console.log("token");
    //console.log(token);
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
      //console.log("decodedToken");
      //console.log(decodedToken);
      if (decodedToken.exp < currentTime) {
        // Token has expired, clear it from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
      }
    }else{
      localStorage.removeItem('user');
      localStorage.removeItem('username');
    }
  };
  useEffect(() => {
    checkTokenExpiration();
  }, [checkTokenExpiration]);
  
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${api}/users/login`, { username, password });

      //console.log('Login successful:', response.data);

      if (response.data.user.status === 1) {
        localStorage.setItem('username', username);
        const { token, expiresAt,users_id } = response.data;

        // Store token and expiration time in localStorage
        localStorage.setItem('token', token);
        localStorage.setItem('expiresAt', expiresAt);
        localStorage.setItem('user_id', users_id);
        window.location.href = '/index';
      } else {
        setErrorPopup(true); // Display error popup
      }
    } catch (error) {
      console.error('Login failed:', error);
      setErrorPopup(true); // Display error popup on login failure
    }
  };

  return (
    <section className='login'>
      <div className='login-container'>
        <div className='left-bg'></div>
        <div className='login-form'>
          <h2 className='login-title'>تسجيل الدخول</h2>
          <form onSubmit={handleLogin}>
           
            <div className='form-group'>
              <label htmlFor='username'>اسم المستخدم:</label>
              <input type='text' id='username' value={username} onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div className='form-group'>
              <label htmlFor='password'>كلمة المرور:</label>
              <input type='password' id='password' value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button type='submit' className='login-btn'> تسجيل الدخول</button>
          </form>
          {errorPopup && (
            <div className='error-popup'>
              <div className='error-content'>
                <p>اسم المستخدم او كلمة المرور غير صحيحة </p>
                <button onClick={() => setErrorPopup(false)}>إغلاق</button>
              </div>
            </div>
          )}
        </div>
        <div className='right-bg'></div>
      </div>
    </section>
  );
};

export default Login;
